import React from "react";
import styled from "styled-components";

const ImumTableTD = ({ val, country, children, countriesAreDisplayed }) => {
  if (countriesAreDisplayed && !countriesAreDisplayed.includes(country))
    return null;
  return (
    <StyledTd2
      country={country}
      border_left={countriesAreDisplayed.at(0) == country}
      border_right={countriesAreDisplayed.at(-1) == country}
    >
      {children ? children : val ? val[country.toLowerCase()] : "-"}
    </StyledTd2>
  );
};
const StyledTd2 = styled.td`
  min-width: 100px;
  text-align: center;
  vertical-align: middle !important;
  background-color: ${(props) =>
    props.country == "LV"
      ? "rgba(200, 82, 96, 0.12)"
      : props.country == "LT"
      ? "rgba(255, 206, 49, 0.12)"
      : props.country == "EE"
      ? "rgba(66, 173, 226, 0.12)"
      : "rgb(0 150 136 / 14%)"};
  border-left: ${(props) =>
    props.border_left ? "1px solid rgb(191, 191, 191)" : "none"};
  border-right: ${(props) =>
    props.border_right ? "1px solid rgb(191, 191, 191)" : "none"};
`;

export default ImumTableTD;
